export const GET_ALL_SSO_DATA = 'GET_ALL_SSO_DATA';
export const GET_ALL_TYPES_DATA = 'GET_ALL_TYPES_DATA';
export const GET_SSO_DETAILS_DATA = 'GET_ALL_SSO_DETAILS_DATA';
export const GET_SSO_VIEW_USER_DATA = 'GET_ALL_SSO_VIEW_USER_DATA';


